import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import AdminListService from "../../../services/admin-list.service";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ToTop from "../includes/ToTop";
import useTable from "../../../hooks/useTable";
import useSortableData from "../../../hooks/useSortableData";
import Select from "react-select";
import Pagination from "react-js-pagination";

export default function Dashboard() {
  const state = useSelector((state) => state.stateVals);

  const { manager_id, manager_role } = state;
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState("20");
  const [active, setActive] = useState("");
  const [filter, setFilter] = useState(null);
  const [resetKey1, setResetKey1] = useState(0);

  const [selectOpt, setSelectOpt] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [totalResults, setTotalResults] = useState("0");
  const [totalPages, setTotalPages] = useState("1");
  const getManagerData = async () => {
    if (manager_id) {
      try {
        setLoading(true);

        const responce = await AdminListService.getManagersDashboardsData(
          manager_id
        );

        setDashboard(responce.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
        if (err?.response?.data?.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            iconColor: "#e04f5d",
            text: err?.response?.data?.message,
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Try Again",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            iconColor: "#e04f5d",
            text: "Some thing went wrong!",
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Try Again",
          });
        }
      }
    }
  };
  useEffect(() => {
    getManagerData();
  }, [manager_id]);

  const getRegister = async (
    type,
    page = 1,
    limit = "20",
    id = null,
    start = null,
    end = null
  ) => {
    setActive(type);
    if (!id) {
      setResetKey1(resetKey1 + 1);
    }

    try {
      setLoading(true);

      const responce = await AdminListService.getRegisterDataByType(
        type,
        manager_id,
        id,
        start,
        end,
        page,
        limit
      );

      const res = responce?.data?.registrations || [];
      setFilter(responce?.data?.filters);

      const resultsReg = [];
      res.map((value) => {
        return resultsReg.push({
          store_location: value.store_location,
          customerEmail: value.email,
          customer_F: value.cust_fname,
          customer_L: value.cust_lname,
          phone: value.phone,
          purchase: value.purchase,

          sales_name: value.sales_name,
          date: value.date,
        });
      });
      setTableData([...resultsReg]);

      setLimit(responce?.data?.per_page || "20");
      setTotalResults(responce?.data?.total_records || "0");
      setTotalPages(responce?.data?.total_pages || "1");
      setCurrentPage(responce?.data?.current_page || "1");
      if (type === "by_store") {
        const results = [];
        dashboard?.by_store?.map((value) => {
          return results.push({
            value: value.store_id,
            label: value.store_location,
          });
        });
        setSelectOpt([...results]);
      } else if (type === "by_hfc") {
        const results = [];
        dashboard?.by_hfc?.map((value) => {
          return results.push({
            value: value.hfc_id,
            label: value.sales_name,
          });
        });
        setSelectOpt([...results]);
      } else {
        setSelectOpt([]);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      setTableData([]);

      setLimit("20");
      setTotalResults("0");
      setTotalPages("1");
      setCurrentPage(1);
    }
  };
  const Table = ({ data, rowsPerPage }) => {
    const [page, setPage] = useState(1);
    const { slice } = useTable(data, page, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);
    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <div className="table-responsive mt-3">
        <table className="table table-striped table-bordered W-100 sort-ths">
          <thead>
            <tr>
              <th
                scope="col"
                onClick={() => requestSort("date")}
                className={getClassNamesFor("date")}
              >
                No.
              </th>
              <th
                scope="col"
                onClick={() => requestSort("date")}
                className={getClassNamesFor("date")}
              >
                Date
              </th>
              <th
                scope="col"
                onClick={() => requestSort("customer_F")}
                className={getClassNamesFor("customer_F")}
              >
                Customer First Name
              </th>
              <th
                scope="col"
                onClick={() => requestSort("customer_L")}
                className={getClassNamesFor("customer_L")}
              >
                Customer Last Name
              </th>

              <th
                scope="col"
                onClick={() => requestSort("customerEmail")}
                className={getClassNamesFor("customerEmail")}
              >
                Customer Email
              </th>
              <th
                scope="col"
                onClick={() => requestSort("phone")}
                className={getClassNamesFor("phone")}
              >
                Customer Phone#
              </th>
              <th
                scope="col"
                onClick={() => requestSort("store_location")}
                className={getClassNamesFor("store_location")}
              >
                Store Location
              </th>
              <th
                scope="col"
                onClick={() => requestSort("sales_name")}
                className={getClassNamesFor("sales_name")}
              >
                HFC
              </th>
              <th
                scope="col"
                onClick={() => requestSort("purchase")}
                className={getClassNamesFor("purchase")}
              >
                Purchase With Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            {items.length ? (
              items.map((el, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{el.date}</td>
                  <td>{el.customer_F}</td>
                  <td>{el.customer_L}</td>
                  <td>{el.customerEmail}</td>
                  <td>{el.phone}</td>
                  <td>{el.store_location}</td>
                  <td>{el.sales_name}</td>
                  <td>{el.purchase}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center text-capitalize">
                  No record found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalResults > limit && totalPages > 1 ? (
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={parseInt(limit)}
            totalItemsCount={totalResults}
            onChange={(e) => {
              getRegister(
                active,
                e,
                limit,
                filter?.id,
                filter?.start_date,
                filter?.end_date
              );
            }}
            pageRangeDisplayed={8}
            itemClass="page-item"
            linkClass="page-link"
            firstPageText="First Page"
            lastPageText="Last Page"
          />
        ) : (
          ""
        )}
      </div>
    );
  };
  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        {/* <div className="col-12 add-space-btns">
          <Link to="/searchcomp_pav" className="btn btn-primary mt-2">
            Mail Merge
          </Link>
          <Link className="btn btn-primary mt-2" to="/searchmail_pav_hard">
            Card to be Mailed
          </Link>
          <Link to="/searchmail_pav_virtual" className="btn btn-primary mt-2">
            Virtual Card
          </Link>
        </div> */}
        <div className="row row-cols-2 row-cols-lg-4 g-2 g-lg-3">
          {manager_role === "administrator" && (
            <div className="col">
              <div
                className={`card ${active === "company_total" ? "active" : ""}`}
              >
                <h6 className="card-header">Company Total</h6>
                <div className="card-body text-center">
                  <h3 className="card-title">
                    {dashboard?.company_total || 0}
                  </h3>

                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      getRegister("company_total", 1, limit);
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="col">
            <div className={`card ${active === "by_store" ? "active" : ""}`}>
              <h6 className="card-header">
                {manager_role === "administrator"
                  ? "All Store Totals"
                  : "Store Total"}{" "}
              </h6>
              <div className="card-body text-center">
                <h3 className="card-title">
                  {dashboard?.by_store?.reduce(
                    (sum, ad) => sum + ad.total_registrations,
                    0
                  ) || 0}
                </h3>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    getRegister("by_store", 1, limit);
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className={`card ${active === "by_hfc" ? "active" : ""}`}>
              <h6 className="card-header">By HFC</h6>
              <div className="card-body text-center">
                <h3 className="card-title">
                  {dashboard?.by_hfc?.reduce(
                    (sum, ad) => sum + ad.total_registrations,
                    0
                  ) || 0}
                </h3>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    getRegister("by_hfc", 1, limit);
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className={`card ${active === "by_date" ? "active" : ""}`}>
              <h6 className="card-header">By Date Range</h6>
              <div className="card-body text-center">
                <h3 className="card-title">
                  {dashboard?.by_date?.reduce(
                    (sum, ad) => sum + ad.total_registrations,
                    0
                  ) || 0}
                </h3>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    getRegister("by_date", 1, limit);
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
        {active && (
          <div className="card mt-4">
            <div className="card-header py-3">
              <h5 className="mb-0 font-22">
                Registered Users [{totalResults || 0}]
                {/* {totalResults > 0 && (
                  <button
                    type="button"
                    // onClick={exportRecord}
                    className="btn btn-primary d-inline-block float-end btn-sm"
                  >
                    Export Record
                  </button>
                )} */}
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="input-field-box mb-lg-0">
                    <label>Show Record</label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        getRegister(
                          active,
                          1,
                          e.target.value,
                          filter?.id,
                          filter?.start_date,
                          filter?.end_date
                        );
                      }}
                    >
                      <option value="20">20</option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                      <option value="1500">1500</option>
                      {/* <option value={totalResults}>All</option> */}
                    </select>
                  </div>
                </div>
                {active === "by_store" || active === "by_hfc" ? (
                  <div className="col-md-3 ms-auto">
                    <div className="input-field-box mb-lg-0">
                      <label>
                        {active === "by_store"
                          ? "Select Store Location"
                          : "Select HFC"}{" "}
                      </label>
                      <div className="input-group">
                        <Select
                          key={resetKey1}
                          className="border-0 form-control form-label mb-0 p-0"
                          placeholder={
                            active === "by_store" ? "Store Location" : "HFC"
                          }
                          options={selectOpt}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(selectedOption) => {
                            setFilter((prev) => ({
                              ...prev,
                              id: selectedOption?.value || null,
                            }));
                            getRegister(
                              active,
                              1,
                              limit,
                              selectedOption?.value || null
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
                {active === "by_date" ? (
                  <div className="col-md-4 ms-auto">
                    <div className="input-field-box mb-lg-0">
                      <label>Select Date Range</label>
                      <div className="input-group">
                        <input
                          type={"date"}
                          className={`form-control `}
                          onChange={(e) => {
                            setFilter((prev) => ({
                              ...prev,
                              start_date: e.target.value || null,
                            }));
                            if (
                              (e.target.value && filter?.end_date) ||
                              (!e.target.value && !filter?.end_date)
                            ) {
                              getRegister(
                                active,
                                1,
                                limit,
                                null,
                                e.target.value,
                                filter?.end_date
                              );
                            }
                          }}
                        />
                        <input
                          type={"date"}
                          className={`form-control `}
                          onChange={(e) => {
                            setFilter((prev) => ({
                              ...prev,
                              end_date: e.target.value || null,
                            }));
                            if (
                              (e.target.value && filter?.start_date) ||
                              (!e.target.value && !filter?.start_date)
                            ) {
                              getRegister(
                                active,
                                1,
                                limit,
                                null,
                                filter?.start_date,
                                e.target.value
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <Table data={tableData} rowsPerPage={limit} />
            </div>
          </div>
        )}
      </main>
      <ToTop />
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
